import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
var LocationSearchComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.LocationSearch;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    },
    modules: ["locations/location-search.tsx -> " + "@dp/xcomp"]
  }
});

var LocationSearchPage = function LocationSearchPage() {
  var store = useStore();
  useEffect(function () {
    store.initComponent("LocationSearch").then(function () {// NOOP
    });
  }, []);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18next.t("title.location_search.pagetitle", {
          defaultValue: "Restaurant Locations"
        })
      })
    }), /*#__PURE__*/_jsx(LocationSearchComp, {})]
  });
};

LocationSearchPage.layout = PageLayout.NB_LAYOUT;
LocationSearchPage.layoutProps = {
  analyticsData: {
    pageName: "locations location-search",
    pageType: "locations location-search",
    productCategoryPageType: "Location Search"
  }
};
export default observer(LocationSearchPage);